export default "__VITE_ASSET__BJsUDeN6__"